const funfacts = [
    "fun fact 1",
    "fun fact 2",
    "fun fact 3",
    "fun fact 4",
    "fun fact 5",
];

export default funfacts;